<template>
    <div v-hover="{ over: onHover, leave: onLeave }" class="tooltip-cursor">
        <slot></slot>
        <span v-if="isActive" ref="tooltipMsg" class="tooltip-msg white-bkg b-1 br px-1 gray-60">{{
            message
        }}</span>
    </div>
</template>

<script>
import { throttled } from 'utils/global.js';

export default {
    name: 'CursorTooltip',
    props: {
        isActive: Boolean,
        message: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            hasMouseMoveEvent: false,
        };
    },
    methods: {
        /**
         * Add event listenner on mouse move if element is disabled and an event not yet exist
         *
         * @param {any} e - mouse hover event
         * @return {void}
         */
        onHover(e) {
            if (!this.hasMouseMoveEvent && this.isActive) {
                e.toElement.addEventListener('mousemove', throttled(20, this.moveTooltip));
                this.hasMouseMoveEvent = true;
            }
        },

        /**
         * Remove event listenner on mouse move if the event exist
         *
         * @param {any} e - mouse leave event
         * @return {void}
         */
        onLeave(e) {
            if (this.hasMouseMoveEvent) {
                e.toElement.removeEventListener('mousemove', this.moveTooltip);
                this.hasMouseMoveEvent = false;
            }
        },
        /**
         * Move the tooltips to follow the mouse
         *
         * @param {any} e - mouse move event
         * @return {void}
         */
        moveTooltip(e) {
            const tooltipMessage = this.$refs.tooltipMsg;

            const x = e.clientX + 5 + 'px',
                y = e.clientY - 25 + 'px';

            tooltipMessage.style.top = y;
            tooltipMessage.style.left = x;
        },
    },
};
</script>

<style lang="scss" scoped>
@use '~@sellsy/styleguide/src/_variables' as *;

.tooltip-cursor .tooltip-msg {
    font-weight: 600;
    display: none;
}
.tooltip-cursor:hover .tooltip-msg {
    display: block;
    position: fixed;
    z-index: 9999;
    overflow: hidden;
}
</style>
